import { setupNewRelicAgent } from './new-relic'
import { setupSentry } from './sentry'

export const setupMetrics = () => {
  setupSentry()
  setupNewRelicAgent()
}
